import { render } from "./autocomplete1.vue?vue&type=template&id=ffef4528"
import script from "./autocomplete1.vue?vue&type=script&lang=js"
export * from "./autocomplete1.vue?vue&type=script&lang=js"

import "./autocomplete1.vue?vue&type=style&index=0&id=ffef4528&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__